import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import * as XLSX from 'xlsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf, faFileExcel, faPrint, faShare } from '@fortawesome/free-solid-svg-icons';
import './report.css';
import { Share } from 'react';

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
let ReportName = "Drop Off Report"


const ReportDetails = () => {
    const { reportID } = useParams();
    const [reportDetails, setReportDetails] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchReportDetails = async () => {
            try {
                const response = await axios.get(`${BASE_URL}api/StockTransReports/DisplayDropOffReport?ReportID=${reportID}`);
                setReportDetails(response.data);
                setLoading(false);
                if (reportID.includes("DO")) {
                    // Code to execute if the string contains the substring
                    ReportName = "Drop Off Report";
                    
                  } 
                  else if(reportID.includes("PU")){
                    // Code to execute if the string does not contain the substring
                    ReportName = "Pick Up Report";
                    
                  }
                  else if(reportID.includes("INV")){
                    // Code to execute if the string does not contain the substring
                    ReportName = "Invoice Report";
                    
                  }


            } catch (error) {
                setError(error);
                setLoading(false);
            }
        };

        fetchReportDetails();
    }, [reportID]);

    const exportToPDF = () => {
        const input = document.getElementById('report-details');
        html2canvas(input).then((canvas) => {
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF('p', 'mm', 'a4');
            const imgProps = pdf.getImageProperties(imgData);
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
            pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
            pdf.save('report.pdf');
        });
    };

    const exportToExcel = () => {
        const ws = XLSX.utils.json_to_sheet(reportDetails);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Report");
        XLSX.writeFile(wb, "report.xlsx");
    };

    const handlePrint = () => {
        window.print();
    };

    const handleShare = async () => {
        try {
            const input = document.getElementById('report-details');
            const canvas = await html2canvas(input);
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF('p', 'mm', 'a4');
            const imgProps = pdf.getImageProperties(imgData);
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
            pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
            // Generate PDF as Blob
            const pdfBlob = pdf.output('blob');
            const pdfFile = new File([pdfBlob], 'report.pdf', { type: 'application/pdf' });

            if (navigator.canShare && navigator.canShare({ files: [pdfFile] })) {
                await navigator.share({
                    files: [pdfFile],
                    title: 'Report PDF',
                    text: 'Please find the attached report PDF.'
                });
            } else {
                alert('Sharing PDF is not supported in this browser. You can still download the PDF.');
            }
        } catch (error) {
            alert('An error occurred while sharing the document.');
        }
    };




    // alert('Share functionality to be implemented.');
    // };

    if (loading) {
        return <p>Loading...</p>;
    }

    if (error) {
        return <p>Error loading report: {error.message}</p>;
    }

    if (reportDetails.length === 0) {
        return <p>No report details available.</p>;
    }

    return (
        <div className="container">
            <div className="card shadow-sm p-4">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <div>
                        <h5 className="fw-bold mb-2">Adroit</h5>
                    </div>
                    <div>
                        <div className="d-grid gap-2 d-md-block">
                            <button onClick={exportToPDF} className="btn btn-primary btn-sm me-2">
                                <FontAwesomeIcon icon={faFilePdf} className="me-1" /> Download
                            </button>
                            <button onClick={handlePrint} className="btn btn-info btn-sm me-2">
                                <FontAwesomeIcon icon={faPrint} className="me-1" /> Print
                            </button>
                            <button onClick={handleShare} className="btn btn-success btn-sm">
                                <FontAwesomeIcon icon={faShare} className="me-1" /> Share
                            </button>

                        </div>
                    </div>
                </div>
                <div className="card-body" id="report-details">
                    <Header report={reportDetails[0]} />
                    <Table reportDetails={reportDetails} reportID={reportID} />
                </div>
                {/* Display note if reportID includes 'DO' */}
                {reportID && reportID.includes("DO") && (
                    <div className="mt-4 alert alert-warning text-center">
                        Please Note: This is not an Invoice
                    </div>
                )}
            </div>
        </div>
    );
};

const Header = ({ report }) => (
    <>
        <div className="d-flex align-items-center mb-4">
            <div className="bg-primary me-2" style={{ width: "10px", height: "4rem" }}></div>
            <div>
                {/* <h2 className="fw-bold mb-0">Drop Off Report</h2> */}
                <h2 className="fw-bold mb-0">{ReportName}</h2>
                <h6 className="mt-0">Promosells</h6>
            </div>
        </div>
        <div className="row mt-5">
            <div className="col-md-6">
                <p className="fw-bold" style={{ fontSize: "1.9rem", marginBottom: "0" }}>{report.vcmx2}</p>
                <p style={{ fontSize: "0.8rem", marginTop: "0" }}>{report.vcmx4}</p>
            </div>
            <div className="col-md-6 text-md-end">
                <p className="fw-bold" style={{ fontSize: "1.9rem" }}>{report.vcmx1}</p>
                <div className="mt-4">
                    <p><span className="fw-bold">Telephone Number:</span> {report.vcmx3}</p>
                    <p><span className="fw-bold">Report ID:</span> {report.vcmx5}</p>
                    <p><span className="fw-bold">Date:</span> {new Date(report.date1).toLocaleDateString()}</p>
                </div>
            </div>
        </div>
    </>
);

const Table = ({ reportDetails, reportID }) => (
    <div className="table-responsive" style={{ overflowX: 'auto', width: '100%', maxWidth: '100vw' }}>
        <table className="table table-striped" style={{ width: '100%', minWidth: 0, tableLayout: 'auto' }}>
            <thead className="bg-dark text-white">
                <tr>
                    <th className="fw-bold">#</th>
                    <th className="fw-bold">Samples</th>
                    <th className="fw-bold">Transaction</th>
                    <th className="fw-bold">Qty</th>
                    <th className="fw-bold">Price</th>
                    <th className="fw-bold">Amt</th>
                </tr>
            </thead>
            <tbody>
                {reportDetails.map((report, index) => (
                    <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{report.vcmx8}</td>
                        <td>{report.vcmx7}</td>
                        <td>{reportID && reportID.includes("PU") ? report.flt2 : report.flt1}</td>
                        <td>{report.flt3}</td>
                        <td>{report.flt4}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    </div>
);

export default ReportDetails;
